import { default as _91slug_93BhwC5NnG1MMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/pages/nepodcento/[slug].vue?macro=true";
import { default as indexT6cbDIwRmYMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/pages/nepodcento/index.vue?macro=true";
import { default as _91slug_93LED5lm8AtzMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/pages/volne-pozice/[slug].vue?macro=true";
import { default as pageFFK3Wz86dnMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testu1VLYbGU3KMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepage7fVIwAtPjyMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articleaOFRe4d7TTMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsoLcNDSgnL6Meta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagIeZdgKw8l2Meta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorjeuCEk5XukMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as category0fr7DawLVIMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionrYGxbdtpj5Meta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlesvkEH7cZoLSMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryUt81q9dASlMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleI8isEExmc5Meta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionhteqleyzNKMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as complaintHLg7orPGtNMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/complaint?macro=true";
import { default as price_45guaranteePp0wtpkFNDMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/price-guarantee?macro=true";
import { default as contactqrlE2Vc9kfMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45termination1zl1SYpzvcMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as mediaguVDjOLVzIMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/press/media?macro=true";
import { default as pressUkOQ2xJ5zVMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/press/press?macro=true";
import { default as slugKrFi7UopC3Meta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/press/slug?macro=true";
import { default as zadostZQtIXi1Y4eMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankcggeq1p2PkMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnaniYjUGf9UcynMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as calculationNqXod4T7MVMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45youl5Ado97dUVMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detail1kJ1JZNoBAMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiry586w7K73QeMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45listzI7tbMXS6gMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculation3FJHbcakJgMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45you21YxsMMWc6Meta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquiryZxczczlwKTMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listfei1t7yDrTMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detailbzVIvFYjxAMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offerjfvBjBMz6EMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiry2ruliQyDBtMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youA9iglAHDabMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculation2kJYY3dF54Meta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listrd5jcYCRkQMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youn2cpNIUQLSMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlineNQ215POVFJMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailDfOKd18aTzMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phoneBsu6Bxk0B4Meta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offerxR36g4qddaMeta } from "/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "nepodcento-slug",
    path: "/nepodcento/:slug()",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/pages/nepodcento/[slug].vue")
  },
  {
    name: "nepodcento",
    path: "/nepodcento",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/pages/nepodcento/index.vue")
  },
  {
    name: "volne-pozice-slug",
    path: "/volne-pozice/:slug()",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/pages/volne-pozice/[slug].vue")
  },
  {
    name: pageFFK3Wz86dnMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testu1VLYbGU3KMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepage7fVIwAtPjyMeta?.name,
    path: "/blog",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articleaOFRe4d7TTMeta?.name,
    path: "/blog/:article(.*)*",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsoLcNDSgnL6Meta?.name,
    path: "/blog/vzory-dokumentu",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagIeZdgKw8l2Meta?.name,
    path: "/blog/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorjeuCEk5XukMeta?.name,
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: category0fr7DawLVIMeta?.name,
    path: "/blog/:category(pojisteni|finance|domacnost)",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionrYGxbdtpj5Meta?.name,
    path: "/blog/:category(pojisteni|finance|domacnost)/:section(auto|cestovani|zivot|dum-a-domacnost|osobni-finance|pujcky-a-uvery|hypoteky|energie|tarify)",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlesvkEH7cZoLSMeta?.name,
    path: "/blog/all-articles",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pageFFK3Wz86dnMeta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryUt81q9dASlMeta?.name,
    path: "/slovnik-pojmu/:category(pojisteni|pujcky-a-uvery|mobilni-tarify-a-internet|energie)",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleI8isEExmc5Meta?.name,
    path: "/slovnik-pojmu/:category(pojisteni|pujcky-a-uvery|mobilni-tarify-a-internet|energie)/:id(.*)*",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionhteqleyzNKMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionhteqleyzNKMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: complaintHLg7orPGtNMeta?.name,
    path: "/reklamace",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/complaint")
  },
  {
    name: price_45guaranteePp0wtpkFNDMeta?.name,
    path: "/garance-nejnizsi-ceny",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/price-guarantee")
  },
  {
    name: contactqrlE2Vc9kfMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45termination1zl1SYpzvcMeta?.name,
    path: "/jak-zmenit-pojistovnu",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: mediaguVDjOLVzIMeta?.name,
    path: "/pro-media",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/press/media")
  },
  {
    name: pressUkOQ2xJ5zVMeta?.name,
    path: "/press",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/press/press")
  },
  {
    name: slugKrFi7UopC3Meta?.name,
    path: "/press/:slug",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/storyblok/pages/press/slug")
  },
  {
    name: zadostZQtIXi1Y4eMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankcggeq1p2PkMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnaniYjUGf9UcynMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: calculationNqXod4T7MVMeta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45youl5Ado97dUVMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detail1kJ1JZNoBAMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiry586w7K73QeMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45listzI7tbMXS6gMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculation3FJHbcakJgMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45you21YxsMMWc6Meta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquiryZxczczlwKTMeta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listfei1t7yDrTMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detailbzVIvFYjxAMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offerjfvBjBMz6EMeta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiry2ruliQyDBtMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youA9iglAHDabMeta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculation2kJYY3dF54Meta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listrd5jcYCRkQMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youn2cpNIUQLSMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlineNQ215POVFJMeta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailDfOKd18aTzMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phoneBsu6Bxk0B4Meta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offerxR36g4qddaMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src4087548962/src/nuxt-srovnejto/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]